export const maskStyle = {
    background: "rgba(204, 120, 255, 0.13)",
    backdropFilter: "blur(37px)"
}
